<template>
    <div class="rich-button" :class="rootClasses" v-bind="cmsEditHelperAttrs">
        <a :href="content.href" :target="content.external ? '_blank' : null"
                :rel="content.external ? 'noopener noreferrer' : null"
                @click="onClick($event)"
                class="rich-button--link btn" :class="buttonClasses">
            <span v-if="content.headline" class="btn--wrap">
                <span class="btn--text rich-button--headline"
                        v-html="content.headline">
                </span>
            </span>
            <span class="rich-button--wrap btn--wrap">
                <span v-if="content.icon" class="rich-button--icon btn--icon">
                    <cmp-icon :symbol="content.icon" size="medium"></cmp-icon>
                </span>
                <span v-if="content.label" class="rich-button--label btn--text" v-html="content.label"></span>
                <span class="rich-button--chevron btn--icon">
                    <cmp-icon symbol="chevron_right" size="x-small"></cmp-icon>
                </span>
            </span>
        </a>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';
    import bemMixin from 'vue/mixins/bem';


    export default {
        mixins: [
            cmsPlugin,
            bemMixin('rich-button'),
        ],
        props: {
            buttonFacet: {
                type: String,
                default: 'primary',
            },
            theme: String,
            plugin: Object,
        },
        computed: {
            rootClasses() {
                const facet = this.content.facet || this.facet;

                return [
                    this.bemAdd(facet),
                ];
            },
            buttonClasses() {
                const buttonFacet = this.content.buttonFacet || this.buttonFacet;
                const theme = this.content.theme || this.theme;

                return [
                    buttonFacet ? `btn__${ buttonFacet }` : '',
                    theme ? `btn__theme-${ theme }` : '',
                ];
            },
        },
        methods: {
            onClick(e) {
                this.$emit('request-action');

                if (!this.content.href || !this.content.external) {
                    e.preventDefault();
                }

                if (!this.content.external) {
                    this.$router.push(this.content.href);
                }
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?e921146c